import { Country } from '@cash-web/shared-util-protos/squareup/common/countries.pb'

import { useRegion } from '../RegionProvider'

export const useCurrencySymbol = () => {
  const regionCode = useRegion()
  return regionCode === Country.GB ? '£' : '$'
}
